module.exports = __webpack_public_path__ + "static/media/logo.4bae0321.png";